import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import {
  FormGroup,
  Input,
  FormText,
  Row,
  Col,
  Label as ReactstrapLabel,
} from 'reactstrap'
import { v4 as uuidv4 } from 'uuid'

export const BottomCheckboxes = ({ field, handleChange }) => {
  const [requiredState, setRequired] = useState(field?.required)
  const [readOnlyState, setReadOnly] = useState(field?.readOnly)
  const [disabledState, setDisabled] = useState(field?.disabled)

  console.log(requiredState, 'leart13')

  return (
    <>
      <div
        className='custom-control custom-checkbox mb-3'
        style={{ zIndex: '0' }}
      >
        <input
          className='custom-control-input'
          id='required'
          type='checkbox'
          checked={requiredState}
          onChange={(e) => {
            setRequired(e.target.checked)
            handleChange('required', e.target.checked)
          }}
        />
        <label className='custom-control-label' htmlFor='required'>
          Required
        </label>
      </div>
      <div
        className='custom-control custom-checkbox mb-3'
        style={{ zIndex: '0' }}
      >
        <input
          className='custom-control-input'
          id='readOnly'
          type='checkbox'
          checked={readOnlyState}
          onChange={(e) => {
            setReadOnly(e.target.checked)
            handleChange('readOnly', e.target.checked)
          }}
        />
        <label className='custom-control-label' htmlFor='readOnly'>
          Read Only
        </label>
      </div>
      <div
        className='custom-control custom-checkbox mb-3'
        style={{ zIndex: '0' }}
      >
        <input
          className='custom-control-input'
          id='disabled'
          type='checkbox'
          checked={disabledState}
          onChange={(e) => {
            setDisabled(e.target.checked)
            handleChange('disabled', e.target.checked)
          }}
        />
        <label className='custom-control-label' htmlFor='disabled'>
          Disabled
        </label>
      </div>
    </>
  )
}

export const MinMaxLengthFields = ({
  field,
  handleChange,
  label = 'Length',
}) => {
  return (
    <>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='minLength'>
          Min {label}
        </label>
        <Input
          key={field?.index}
          id='minLength'
          type='number'
          name='minLength'
          defaultValue={field?.min}
          style={{ height: '38px' }}
          onChange={(e) => handleChange('min', e.target.value)}
        />
      </FormGroup>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='maxLength'>
          Max {label}
        </label>
        <Input
          key={field?.index}
          id='maxLength'
          type='number'
          name='maxLength'
          defaultValue={field?.max}
          style={{ height: '38px' }}
          onChange={(e) => handleChange('max', e.target.value)}
        />
      </FormGroup>
    </>
  )
}

export const LPPH = ({ field, handleChange }) => {
  return (
    <>
      <Label field={field} handleChange={handleChange} />
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='placeholder'>
          Placeholder
        </label>
        <Input
          key={field?.index}
          id='placeholder'
          type='placeholder'
          name='placeholder'
          defaultValue={field?.placeholder}
          style={{ height: '38px' }}
          onChange={(e) => handleChange('placeholder', e.target.value)}
        />
      </FormGroup>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='predefinedValue'>
          Predefined Value
        </label>
        <Input
          key={field?.index}
          id='predefinedValue'
          type='predefinedValue'
          name='predefinedValue'
          defaultValue={field?.value}
          style={{ height: '38px' }}
          onChange={(e) => handleChange('value', e.target.value)}
        />
      </FormGroup>
      <HelpText field={field} handleChange={handleChange} />
    </>
  )
}

export const HelpText = ({ field, handleChange }) => {
  return (
    <FormGroup className='ml-0'>
      <label className='form-control-label' htmlFor='help'>
        Help Text
      </label>
      <Input
        key={field?.index}
        id='help'
        type='help'
        name='help'
        defaultValue={field?.helpText}
        style={{ height: '38px' }}
        onChange={(e) => handleChange('helpText', e.target.value)}
      />
    </FormGroup>
  )
}

export const Label = ({ field, handleChange }) => {
  return (
    <FormGroup className='ml-0'>
      <label className='form-control-label' htmlFor='label'>
        Label
      </label>
      <Input
        key={field?.index}
        id='label'
        type='label'
        name='label'
        defaultValue={field?.label}
        style={{ height: '38px' }}
        onChange={(e) => handleChange('label', e.target.value)}
      />
    </FormGroup>
  )
}

export const CheckboxOptions = ({ field, handleChange, labelText }) => {
  const [options, setOptions] = useState([])

  const handleAddOption = (index) => {
    const newOption = { label: 'Choice', checked: false, id: uuidv4() }
    const updatedOptions = [
      ...options.slice(0, index + 1),
      newOption,
      ...options.slice(index + 1),
    ]

    setOptions(updatedOptions)
    handleChange('options', updatedOptions)
  }

  const updateCheckedStatus = (index) => {
    const checkbox = options[index]
    const updatedOptions = [...options]

    updatedOptions[index] = { ...checkbox, checked: !checkbox.checked }

    setOptions(updatedOptions)
    handleChange('options', updatedOptions)
  }

  const updateOptionLabel = (index, label) => {
    const checkbox = options[index]
    const updatedOptions = [...options]

    updatedOptions[index] = { ...checkbox, label }

    setOptions(updatedOptions)
    handleChange('options', updatedOptions)
  }

  const updateRadioStatus = (index) => {
    const checkbox = options[index]
    const updatedOptions = options.map((option) => {
      return { ...option, checked: false }
    })

    updatedOptions[index] = { ...checkbox, checked: !checkbox.checked }

    setOptions(updatedOptions)
    handleChange('options', updatedOptions)
  }

  const label = {
    checkbox: 'Checkboxes',
    radio: 'Radios',
    select: 'Options',
  }

  useEffect(() => {
    setOptions(field?.options)
  }, [field.index, field.options])

  console.log(options, 'leart245')

  return (
    <>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='maxLength'>
          {label[field.type]}
        </label>

        <div
          className='border p-2 d-flex flex-column'
          style={{ gap: '0.5rem' }}
        >
          {options?.map((option, index) => (
            <div className='d-flex align-items-center'>
              <input
                type='checkbox'
                checked={option.checked}
                onChange={() => {
                  if (field.type === 'checkbox') {
                    updateCheckedStatus(index)
                  } else {
                    updateRadioStatus(index)
                  }
                }}
              />
              <Input
                key={`${field.index}-${option.id}`}
                id='placeholder'
                type='placeholder'
                name='placeholder'
                value={option?.label}
                onChange={(e) => updateOptionLabel(index, e.target.value)}
                style={{ height: '38px' }}
                className='mx-2'
              />
              <FontAwesomeIcon
                icon={faPlusCircle}
                className='text-success mr-2'
                role='button'
                onClick={() => handleAddOption(index)}
              />
              <FontAwesomeIcon
                icon={faMinusCircle}
                className='text-danger'
                role='button'
                onClick={() => {
                  const updatedOptions = options.filter(
                    (element) => element.id !== option.id
                  )
                  setOptions(updatedOptions)
                  handleChange('options', updatedOptions)
                }}
              />
            </div>
          ))}
        </div>
      </FormGroup>
    </>
  )
}

export const ParagraphHeadingText = ({ field, handleChange }) => {
  return (
    <FormGroup className='ml-0'>
      <label className='form-control-label' htmlFor='text'>
        Text
      </label>
      <Input
        key={field?.index}
        id='text'
        type='text'
        name='text'
        defaultValue={field?.text}
        onChange={(e) => handleChange('text', e.target.value)}
        style={{ height: '38px' }}
      />
    </FormGroup>
  )
}

export const WidthHeight = ({ field, handleChange, type }) => {
  return (
    <FormGroup className='ml-0'>
      <label className='form-control-label text-capitalize' htmlFor={type}>
        {type}
      </label>
      <Input
        key={field?.index}
        id={type}
        type='number'
        name={type}
        defaultValue={type === 'width' ? field.width : field.height}
        onChange={(e) => handleChange(type, e.target.value)}
        style={{ height: '38px' }}
      />
    </FormGroup>
  )
}

// Accept File Types component for file fields
export const AcceptFileTypes = ({ field, updateFieldValue }) => {
  const handleAcceptTypesChange = (e) => {
    updateFieldValue(field.id, 'acceptTypes', e.target.value)
  }

  return (
    <FormGroup className='mt-4'>
      <ReactstrapLabel htmlFor='acceptTypes' className='form-control-label'>
        Accepted File Types
      </ReactstrapLabel>
      <Input
        type='text'
        id='acceptTypes'
        name='acceptTypes'
        placeholder='.pdf,.doc,.docx,.jpg,.png'
        value={field.acceptTypes || ''}
        onChange={handleAcceptTypesChange}
        style={{ height: '38px' }}
      />
      <FormText color='muted'>
        Specify file extensions separated by commas (e.g., .pdf,.doc,.jpg)
      </FormText>
    </FormGroup>
  )
}

// Min/Max File Size component for file fields
export const MinMaxFileSize = ({ field, updateFieldValue }) => {
  const handleMinSizeChange = (e) => {
    updateFieldValue(field.id, 'minSize', e.target.value)
  }

  const handleMaxSizeChange = (e) => {
    updateFieldValue(field.id, 'maxSize', e.target.value)
  }

  return (
    <FormGroup className='mt-4'>
      <ReactstrapLabel className='form-control-label'>
        File Size Limits (MB)
      </ReactstrapLabel>
      <Row>
        <Col md='6'>
          <ReactstrapLabel htmlFor='minSize' className='form-control-label'>
            Min Size
          </ReactstrapLabel>
          <Input
            type='number'
            id='minSize'
            name='minSize'
            min='0'
            step='0.1'
            value={field.minSize || ''}
            onChange={handleMinSizeChange}
            style={{ height: '38px' }}
          />
        </Col>
        <Col md='6'>
          <ReactstrapLabel htmlFor='maxSize' className='form-control-label'>
            Max Size
          </ReactstrapLabel>
          <Input
            type='number'
            id='maxSize'
            name='maxSize'
            min='0'
            step='0.1'
            value={field.maxSize || ''}
            onChange={handleMaxSizeChange}
            style={{ height: '38px' }}
          />
        </Col>
      </Row>
    </FormGroup>
  )
}
